import parse from 'html-react-parser';
import { CheckboxElementType } from "../helpers/types";

type Props = {
    value: string;
    onChange: (checked: string) => void;
    error: string | null;
}

const Checkbox = (props: CheckboxElementType & Props) => {
    const { value, onChange, label, name, required, description } = props;

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const isChecked = event.target.checked;
        onChange(isChecked.toString())
    };

    return (
        <>
        {description && <div className="text-muted small mb-2">{parse(description)}</div>}
        <div className="form-check mt-2" key={name}>
            <input
                type="checkbox"
                id={name}
                name={name}
                required={required}
                className="form-check-input"
                onChange={handleChange}
                checked={value == 'true' ? true : false}
            />
            <label htmlFor={name} className="form-check-label">
                {label}
            </label>
        </div>
        </>
    )
}

export default Checkbox;